import type { ReactNode } from "react";

import { Box } from "@/compat/radix-themes";

interface LayoutProps {
  children: ReactNode;
}

const AuthLayout = ({ children }: LayoutProps) => {
  return (
    <Box className="min-h-screen w-full bg-background text-foreground">
      {children}
    </Box>
  );
};

export default AuthLayout;
